"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_icon_1 = require("@hopin-team/ui-icon");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = (0, tslib_1.__importDefault)(require("react"));

var root_1 = require("./styled/root");

var Badge = function Badge(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      children = _a.children,
      _b = _a.colorPattern,
      colorPattern = _b === void 0 ? 'primary' : _b,
      className = _a.className,
      leadingIcon = _a.leadingIcon,
      _c = _a.pattern,
      pattern = _c === void 0 ? 'default' : _c,
      _d = _a.priority,
      priority = _d === void 0 ? 'high' : _d,
      _e = _a.shape,
      shape = _e === void 0 ? 'simple' : _e,
      label = _a.label,
      trailingIcon = _a.trailingIcon,
      ariaAttributes = (0, tslib_1.__rest)(_a, ["__UIScope", 'data-testid', "children", "colorPattern", "className", "leadingIcon", "pattern", "priority", "shape", "label", "trailingIcon"]);
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Badge',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  return react_1.default.createElement(root_1.Root, (0, tslib_1.__assign)({
    className: rootClasses,
    "data-testid": testID,
    shape: shape,
    colorPattern: colorPattern,
    withIcon: Boolean(leadingIcon || trailingIcon),
    pattern: pattern,
    priority: priority
  }, ariaAttributes), leadingIcon && react_1.default.createElement(ui_icon_1.Icon, {
    name: leadingIcon,
    title: leadingIcon,
    "aria-hidden": true,
    mr: 1
  }), children, react_1.default.createElement(ui_text_1.Text, {
    pattern: pattern === 'notification' ? 'captionSmall' : 'captionMedium'
  }, label), trailingIcon && react_1.default.createElement(ui_icon_1.Icon, {
    name: trailingIcon,
    title: trailingIcon,
    "aria-hidden": true,
    ml: 1
  }));
};

var BadgeWithSpace = (0, ui_helper_with_space_1.withSpace)(Badge);
exports.Badge = BadgeWithSpace;